import {instance as userService} from '../services/UserService'

export const supportedLanguages = ['ru', 'en'] as const
export type Language = (typeof supportedLanguages)[number]

const ruLocale = ['ru', 'ru-BY', 'ru-KG', 'ru-KZ', 'ru-MD', 'ru-RU', 'ru-UA', 'be', 'be-BY']

const browserLanguageLocale = ruLocale.includes(navigator.language) ? 'ru' : 'en'

const userDefinedSavedLocale = userService.getSavedUserLocale()

export const defaultLocale = (userDefinedSavedLocale as 'ru' | 'en') || browserLanguageLocale
